<template>
  <!-- Which group is open is the list's to say in Vuetify 3 (`opened`), where
       Vuetify 2 had a v-model on each group. It follows the route the same
       way: the group the current page belongs to opens, the others close. -->
  <v-list v-model:opened="opened" density="compact">
    <template v-for="item in items" :key="item.text">
      <v-list-group v-if="item.children" :value="item.text">
        <!-- Vuetify 3 hands the activator its own props instead of a bare slot. -->
        <template #activator="{ props }">
          <v-list-item v-bind="props" :prepend-icon="item.icon">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </template>
        <template v-for="(child, i) in item.children" :key="i">
          <!-- A group inside the group (Süsteem -> Turvalisus -> Kliendid). -->
          <v-list-group v-if="child.children" :value="item.text + '/' + child.text">
            <template #activator="{ props }">
              <v-list-item v-bind="props">
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item v-for="(grand, j) in child.children" :key="j" :to="grand.link" link>
              <v-list-item-title>{{ grand.text }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :to="child.link" link>
            <v-list-item-title>{{ child.text }}</v-list-item-title>
          </v-list-item>
          <v-divider v-if="child.divider" />
        </template>
      </v-list-group>
      <!-- href is for a link out of this SPA (the akt module lives at /akt and
           has its own router); Vuetify renders an <a> when there is no `to`. -->
      <v-list-item v-else :to="item.link" :href="item.href" link>
        <template #prepend>
          <v-icon>{{ item.icon }}</v-icon>
        </template>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  props: {
    items: {
      required: true
    }
  },
  data () {
    return {
      opened: []
    }
  },
  methods: {
    isHere (link) {
      try {
        const path = typeof link === 'string' ? link : this.$router.resolve(link).path
        return this.$route.path === path || this.$route.path.startsWith(path + '/')
      } catch (err) {
        return false
      }
    }
  },
  watch: {
    items: {
      handler (items) {
        const open = items.filter(item => item.children && item.model)
        // The sub-group of the current page opens with its group.
        const sub = open.flatMap(item => item.children
          .filter(child => child.children && child.children.some(grand => this.isHere(grand.link)))
          .map(child => item.text + '/' + child.text))
        this.opened = [...open.map(item => item.text), ...sub]
      },
      immediate: true
    }
  }
}
</script>
